<!-- Custom Tab Header -->
<div class="custom-tab-header card p-10">
  <div class="tab-button" 
       *ngFor="let tab of tabs; let i = index"
       [class.active]="selectedTypeTabName === tab.key"
       (click)="selectTab(tab.key)">
    <span class="material-icons mr-5">{{ tab.icon }}</span>
    {{ tab.label }}
  </div>
</div>

<!-- Tab Content (keep this as is) -->
<div class="card attritionTab">
  <div class="p-10" *ngIf="selectedTypeTabName === 'attendance-report'">
    <app-attendance-report></app-attendance-report>
  </div>
  <div class="p-10" *ngIf="selectedTypeTabName === 'upcomingtraining'">
    <app-upcoming-trainings></app-upcoming-trainings>
  </div>
  <div class="p-10" *ngIf="selectedTypeTabName === 'reactivefeedback'">
    <app-reactive-feedback></app-reactive-feedback>
  </div>
  <div class="p-10" *ngIf="selectedTypeTabName === 'joblearningfeedback'">
    <app-job-learning-feedback></app-job-learning-feedback>
  </div>
  <div class="p-10" *ngIf="selectedTypeTabName === 'jobbehaviorfeedback'">
    <app-job-behavior-feedback></app-job-behavior-feedback>
  </div>
</div>
